(function () {
  function boot() {
    var root = document.querySelector("[data-chb-nav]");
    if (!root) return;

    var items = root.querySelectorAll(".chb-nav-item");
    var mega = root.querySelector("[data-nav-mega]");
    var dim = root.querySelector("[data-nav-dim]");
    var panels = root.querySelectorAll("[data-panel]");
    var burger = document.querySelector(".chb-nav-burger");
    var drawer = document.getElementById("chb-nav-drawer");
    var closeBtn = document.querySelector(".chb-nav-close");
    var timer = 0;
    var openKey = "";
    var desk = window.matchMedia("(min-width: 1025px)");

    function isDesk() {
      return desk.matches;
    }

    function place() {
      if (mega) mega.style.removeProperty("top");
      if (dim) dim.style.removeProperty("top");
    }

    function showPanel(key) {
      openKey = key;
      items.forEach(function (btn) {
        var on = btn.getAttribute("data-nav") === key;
        btn.classList.toggle("is-active", on);
        btn.setAttribute("aria-expanded", on ? "true" : "false");
      });
      panels.forEach(function (p) {
        var on = p.getAttribute("data-panel") === key;
        p.classList.toggle("is-on", on);
        if (on) {
          p.querySelectorAll("img").forEach(function (img) {
            if (img.getAttribute("loading") === "lazy") img.loading = "eager";
            if (!img.complete && img.src) img.src = img.src;
          });
        }
      });
    }

    function openMega(key) {
      if (!isDesk() || !key) return;
      place();
      showPanel(key);
      if (mega) mega.hidden = false;
      if (dim) dim.hidden = false;
    }

    function closeMega() {
      if (mega) mega.hidden = true;
      if (dim) dim.hidden = true;
      openKey = "";
      items.forEach(function (btn) {
        btn.classList.remove("is-active");
        btn.setAttribute("aria-expanded", "false");
      });
    }

    function scheduleClose() {
      clearTimeout(timer);
      timer = setTimeout(closeMega, 420);
    }

    function keepOpen() {
      clearTimeout(timer);
    }

    function relocate() {
      var head = document.querySelector(".chb-head");
      if (head && burger && burger.parentNode !== head) {
        head.appendChild(burger);
      }
      if (drawer && drawer.parentNode !== document.body) {
        document.body.appendChild(drawer);
      }
      if (mega && mega.parentNode !== root) root.appendChild(mega);
      if (dim && dim.parentNode !== root) root.appendChild(dim);
      place();
    }

    relocate();

    function clearStick() {
      ["position", "top", "left", "right", "width", "z-index"].forEach(function (p) {
        root.style.removeProperty(p);
      });
      var spacer = document.querySelector(".chb-nav-spacer");
      if (spacer && spacer.parentNode) spacer.parentNode.removeChild(spacer);
      document.body.classList.remove("chb-header-stuck");
    }
    clearStick();

    items.forEach(function (btn) {
      btn.addEventListener("mouseenter", function () {
        if (!isDesk()) return;
        var key = btn.getAttribute("data-nav");
        if (!key) {
          closeMega();
          return;
        }
        keepOpen();
        openMega(key);
      });
      btn.addEventListener("focus", function () {
        if (!isDesk()) return;
        var key = btn.getAttribute("data-nav");
        if (!key) {
          closeMega();
          return;
        }
        keepOpen();
        openMega(key);
      });
    });

    if (mega) {
      mega.addEventListener("mouseenter", keepOpen);
      mega.addEventListener("mouseleave", function () {
        if (isDesk()) scheduleClose();
      });
    }
    root.addEventListener("mouseleave", function () {
      if (isDesk()) scheduleClose();
    });
    root.addEventListener("mouseenter", keepOpen);
    if (dim) {
      dim.addEventListener("click", function () {
        closeMega();
        if (!isDesk()) closeDrawer();
      });
    }

    items.forEach(function (btn) {
      btn.addEventListener("click", function (event) {
        if (!isDesk()) return;
        var key = btn.getAttribute("data-nav");
        if (!key) return;
        event.preventDefault();
        keepOpen();
        openMega(key);
      });
    });
    root.addEventListener("keydown", function (event) {
      if (!isDesk()) return;
      var current = document.activeElement;
      if (!current || !current.classList || !current.classList.contains("chb-nav-item")) return;
      var list = [];
      items.forEach(function (el) {
        if (el.getAttribute("data-nav")) list.push(el);
      });
      var index = list.indexOf(current);
      if (index < 0) return;
      if (event.key === "ArrowRight" || event.key === "ArrowLeft") {
        event.preventDefault();
        var step = event.key === "ArrowRight" ? 1 : -1;
        list[(index + step + list.length) % list.length].focus();
      }
      if (event.key === "ArrowDown") {
        event.preventDefault();
        openMega(current.getAttribute("data-nav"));
        var first = mega && mega.querySelector(".chb-nav-panel.is-on a");
        if (first) first.focus();
      }
    });

    function openDrawer() {
      if (!drawer || isDesk()) return;
      drawer.hidden = false;
      if (dim) {
        dim.hidden = false;
        if (dim.parentNode !== document.body) document.body.appendChild(dim);
      }
      document.body.classList.add("chb-nav-lock");
      if (burger) burger.setAttribute("aria-expanded", "true");
      if (closeBtn) closeBtn.focus();
    }
    function closeDrawer() {
      if (!drawer) return;
      var wasPhone = document.body.classList.contains("chb-nav-lock");
      drawer.hidden = true;
      document.body.classList.remove("chb-nav-lock");
      if (burger) burger.setAttribute("aria-expanded", "false");
      if (wasPhone && burger) burger.focus();
      if (wasPhone && dim) {
        dim.hidden = true;
        if (root && dim.parentNode !== root) root.appendChild(dim);
      }
    }
    if (burger) {
      burger.addEventListener("click", function () {
        if (drawer && drawer.hidden === false) closeDrawer();
        else openDrawer();
      });
    }
    if (closeBtn) closeBtn.addEventListener("click", closeDrawer);

    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") {
        closeMega();
        closeDrawer();
      }
    });

    function syncCartLayer() {
      var open = document.querySelector(".header-cart.is-open");
      document.body.classList.toggle("chb-cart-open", !!open);
      if (open) closeMega();
    }
    document.addEventListener(
      "click",
      function (e) {
        if (e.target.closest(".header-cart")) {
          closeMega();
          setTimeout(syncCartLayer, 0);
        } else {
          setTimeout(syncCartLayer, 0);
        }
      },
      true
    );
    document.addEventListener("mouseover", function (e) {
      if (e.target.closest && e.target.closest(".header-cart")) closeMega();
    });
    if (window.jQuery) {
      window.jQuery(document.body).on("cfw_open_side_cart", function () {
        closeMega();
        document.body.classList.remove("chb-cart-open");
        document.querySelectorAll(".header-cart.is-open").forEach(function (el) {
          el.classList.remove("is-open");
        });
      });
    }

    // Keep keyboard focus inside the open mobile dialog.
    document.addEventListener("keydown", function (event) {
      if (event.key !== "Tab" || !drawer || drawer.hidden || isDesk()) return;
      var focusable = Array.from(drawer.querySelectorAll('a[href],button:not([disabled]),summary,[tabindex="0"]')).filter(function (el) { return el.getClientRects().length > 0; });
      if (!focusable.length) return;
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    if (drawer) drawer.addEventListener("click", function (event) {
      if (event.target.closest("a[href]")) closeDrawer();
    });

    function onBreak() {
      if (!isDesk()) closeMega();
      else closeDrawer();
      relocate();
      clearStick();
    }
    if (desk.addEventListener) desk.addEventListener("change", onBreak);
    else if (desk.addListener) desk.addListener(onBreak);
    window.addEventListener("resize", place);
    window.addEventListener("scroll", place, { passive: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();

